<template>
  <div class="mc-delivery-request">
    <PageHeader :title="title" :subTitle="subTitle" />

    <b-card class="mc-card__setting">
      <b-tabs lazy content-class="p-4">
        <b-tab :title="$t('deliveryRequest.tabs.delivery')" active>
          <McTable
            stickyHeader
            withCard
            searchable
            :hasCheckbox="false"
            :fields="fields"
            :apiClient="apiClient"
            :hasSelectAll="false"
            :activeFilters="activeFilters"
            :customHandlers="customHandlers"
          >
            <template #before-table="{}">
              <div class="d-flex justify-content-between mb-3">
                <McInlineFilter
                  :filterItems="inlineFilterItems"
                  :activeKeys="activeFilters['status.name']"
                  @update:activeKeys="
                    handleChangeActiveFilters([{ key: 'status.name', values: $event }])
                  "
                />

                <!-- TODO: Delete the v-if for the next development -->
                <ActionsDropdown v-if="false" />
              </div>
            </template>

            <!-- Request Status -->
            <template #cell(status.name)="{ value, item }">
              <template>
                <span
                  v-if="item.status?.color"
                  class="__status-dots"
                  :style="{ backgroundColor: item.status.color }"
                ></span>
                <span class="mc-text-status">{{ statusKeys[value] }}</span>
              </template>
            </template>

            <!-- Delivered Target -->
            <template #cell(parent_expected_delivered_on)="{ value }">
              {{ formatIndexDate(value).date }}
            </template>

            <!-- Delivery Order Number -->
            <template #cell(delivery_order.number)="{ value, item }">
              <span
                v-if="value"
                @click="() => handleClickRow(item, 'delivery_order.number')"
                class="mc-delivery-request__delivery-number text-primary"
                >{{ value }}</span
              >
              <span v-else>-</span>
            </template>

            <!-- Load Weight -->
            <template #cell(parent_load_weight)="{ value }">
              {{ value.toLocaleString() }} Kg
            </template>

            <!-- Load Volume -->
            <template #cell(parent_load_volume)="{ value }">
              {{ value.toLocaleString() }} Cbm
            </template>
          </McTable>
        </b-tab>
        <b-tab :title="$t('deliveryRequest.tabs.fleetTask')">
          <ListFleetTask />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import appConfig from '@/app.config'

import PageHeader from '@/components/page-header-v2'
import McInlineFilter from '@/components/McInlineFilter'
import McTable from '@/components/McTable'
import ActionsDropdown from '../components/ActionsDropdown'
import ListFleetTask from './ListFleetTask.vue'

import * as Request from '@/services/rest-api/lib/request/request'

import fields from '../lib/fields/list-table-fields'
import inlineFilterItems from '../lib/constants/inline-filter-items'
import statusKeys from '../lib/constants/status-keys'
import filterMappings from '../lib/constants/filter-mappings'
import { formatIndexDate } from '@/helpers/tzDate'

export default {
  page: {
    title: 'Delivery Request',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    McInlineFilter,
    McTable,
    ActionsDropdown,
    ListFleetTask,
  },
  data() {
    return {
      activeFilters: {},
    }
  },
  computed: {
    title() {
      return this.$t('deliveryRequest.list.title')
    },
    subTitle() {
      return this.$t('deliveryRequest.list.subtitle')
    },
    fields() {
      return fields(this.$t.bind(this))
    },
    inlineFilterItems() {
      return inlineFilterItems(this.$t.bind(this))
    },
    statusKeys() {
      return statusKeys(this.$t.bind(this))
    },
    apiClient() {
      let getRequest = Request.get()

      if (Object.keys(this.activeFilters).length > 0) {
        const queryParamFilters = []

        // mapping the activeFilters to be sent as query params
        Object.keys(this.activeFilters).forEach((key) => {
          const filter = filterMappings[key]?.(key, this.activeFilters[key]) ?? undefined
          queryParamFilters.push(filter)
        })
        getRequest = Request.get(queryParamFilters)
      }

      return {
        get: getRequest,
      }
    },
    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
      }
    },
  },
  methods: {
    formatIndexDate,
    handleClickRow(item, rowKey) {
      let name = 'Delivery Request Detail'
      let id = item.id

      if (rowKey == 'delivery_order.number') {
        name = 'Delivery Detail'
        id = item.delivery_order.id
      }

      this.$router.push({ name, params: { id } })
    },
    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        // to reset the filter values
        this.$delete(this.activeFilters, filter.key)

        // to prevent set the filter in activeFilters if values are null or undefined
        if (filter.values === null || filter.values === undefined || filter.values === '') return
        // to prevent set the filter in activeFilters if values are Array with length equal to 0
        if (Array.isArray(filter.values) && filter.values.length === 0) return
        
        // set the key and values in activeFilters
        this.$set(this.activeFilters, filter.key, filter.values)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-delivery-request {
  .__status-dots {
    display: inline-block;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }

  .mc-text-status {
    font-weight: 600;
  }

  &__delivery-number {
    cursor: pointer;
  }
}
</style>
